export default "<app-page-content pageUrl=\"sez-investments/one-stop-investors-service-centre\"></app-page-content>\r\n"